export function getSearchParams(url: string)
{
    const searchParams = url.split('?')[1];

    return new URLSearchParams(searchParams);
}
